import { render, staticRenderFns } from "./fansData.vue?vue&type=template&id=361b4b5c&scoped=true"
import script from "./fansData.vue?vue&type=script&lang=js"
export * from "./fansData.vue?vue&type=script&lang=js"
import style0 from "./fansData.vue?vue&type=style&index=0&id=361b4b5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361b4b5c",
  null
  
)

export default component.exports